import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useHttp } from 'shared/providers/provide-http';
import { EndUserPricingGroupDropdown, TableDataResponse } from 'types/backend';

export function useGetEndUserPricingGroupDropdown(accountNumber: string) {
    const { enqueueSnackbar } = useSnackbar();
    const http = useHttp();
    const response = useQuery<TableDataResponse<EndUserPricingGroupDropdown>, Error>(
        ['enduserpricinggroupdropdown', accountNumber],
        async () => {
            const { data } = await http.get(`api/enduserpricinggroupdropdown/${accountNumber}`);
            return data || [];
        },
        {
            onError: (error) => enqueueSnackbar(error.message, { variant: 'error' }),
            keepPreviousData: true,
            refetchOnWindowFocus: false,
        }
    );
    return response;
}
